export const secondary = {
    100: '#FFFFFF',
    98: '#FFF8F2',
    95: '#FFEFD3',
    90: '#FFDF9D',
    80: '#F8BE1C',
    70: '#D8A300',
    60: '#B78A00',
    50: '#977100',
    40: '#785A00',
    30: '#5B4300',
    20: '#3F2E00',
    10: '#251A00',
    0: '#000000',
};
export default secondary;
